/**
 * 筋模型拓扑绑定构建。
 *
 * 设计说明：
 * 1. 筋的输入真相是“上游实体 + 轮廓”，其上游实体引用必须收口到 `model-topology` binding，
 *    否则依赖图与删除计划器无法追踪；
 * 2. 轮廓由草图 profile 子系统负责，本层只声明筋对基体的消费关系；
 * 3. 上层命令适配器与编辑桥统一复用本函数，避免重复拼 `referenceBindings`。
 */

import { ModelTopologyFeatureBinding } from './ModelTopologyFeatureBinding';

/**
 * 构建筋模型拓扑绑定。
 *
 * @param input 构建输入。
 * @returns 可写入命令参数的绑定列表。
 */
export function buildRibModelTopologyBindings(input: {
    upstreamBodyObjectId?: string | null;
    definition: RibFeatureDefinition;
}): SerializedFeatureReferenceBinding[] {
    // 轮廓绑定由草图 profile 链路另行补充；此处必须声明对上游实体的引用。
    const bodyObjectId = input.upstreamBodyObjectId ?? null;
    if (!bodyObjectId) {
        return [];
    }
    return [
        ModelTopologyFeatureBinding.createPayload({
            bodyObjectId,
            items: [],
        }),
    ];
}
